<span><a :href="resolvedHref" :target="control.data.target">{{ control.data.text }}</a></span>